import { DataAction, ErrorAction, EmptyAction } from './utils';
import { Template } from '../../models/truck';

export enum ActionType {
  GET_TRUCK_TEMPLATES_REQUEST = 'GET_TRUCK_TEMPLATES/REQUEST',
  GET_TRUCK_TEMPLATES_FAILURE = 'GET_TRUCK_TEMPLATES/FAILURE',
  GET_TRUCK_TEMPLATES_SUCCESS = 'GET_TRUCK_TEMPLATES/SUCCESS',
  CREATE_TRUCK_TEMPLATES_REQUEST = 'CREATE_TRUCK_TEMPLATES/REQUEST',
  CREATE_TRUCK_TEMPLATES_FAILURE = 'CREATE_TRUCK_TEMPLATES/FAILURE',
  CREATE_TRUCK_TEMPLATES_SUCCESS = 'CREATE_TRUCK_TEMPLATES/SUCCESS',
  UPDATE_TRUCK_TEMPLATES_REQUEST = 'UPDATE_TRUCK_TEMPLATES/REQUEST',
  UPDATE_TRUCK_TEMPLATES_FAILURE = 'UPDATE_TRUCK_TEMPLATES/FAILURE',
  UPDATE_TRUCK_TEMPLATES_SUCCESS = 'UPDATE_TRUCK_TEMPLATES/SUCCESS',
  DELETE_TRUCK_TEMPLATES_REQUEST = 'DELETE_TRUCK_TEMPLATES/REQUEST',
  DELETE_TRUCK_TEMPLATES_FAILURE = 'DELETE_TRUCK_TEMPLATES/FAILURE',
  DELETE_TRUCK_TEMPLATES_SUCCESS = 'DELETE_TRUCK_TEMPLATES/SUCCESS',

}

export type GetTruckTemplatesRequestAction = EmptyAction<ActionType.GET_TRUCK_TEMPLATES_REQUEST>;
export type GetTruckTemplatesSuccessAction = DataAction<ActionType.GET_TRUCK_TEMPLATES_SUCCESS, Template[]>;
export type GetTruckTemplatesFailureAction = ErrorAction<ActionType.GET_TRUCK_TEMPLATES_FAILURE>;

export type GetTruckTemplatesAction =
  GetTruckTemplatesRequestAction |
  GetTruckTemplatesSuccessAction |
  GetTruckTemplatesFailureAction;

export type CreateTruckTemplatesRequestAction = DataAction<ActionType.CREATE_TRUCK_TEMPLATES_REQUEST, Omit<Template, 'id'>>;
export type CreateTruckTemplatesSuccessAction = DataAction<ActionType.CREATE_TRUCK_TEMPLATES_SUCCESS, Template>;
export type CreateTruckTemplatesFailureAction = ErrorAction<ActionType.CREATE_TRUCK_TEMPLATES_FAILURE>;

export type CreateTruckTemplatesAction =
  CreateTruckTemplatesRequestAction |
  CreateTruckTemplatesSuccessAction |
  CreateTruckTemplatesFailureAction;

export type UpdateTruckTemplatesRequestAction = DataAction<ActionType.UPDATE_TRUCK_TEMPLATES_REQUEST, Template>;
export type UpdateTruckTemplatesSuccessAction = DataAction<ActionType.UPDATE_TRUCK_TEMPLATES_SUCCESS, Template>;
export type UpdateTruckTemplatesFailureAction = ErrorAction<ActionType.UPDATE_TRUCK_TEMPLATES_FAILURE>;

export type UpdateTruckTemplatesAction =
  UpdateTruckTemplatesRequestAction |
  UpdateTruckTemplatesSuccessAction |
  UpdateTruckTemplatesFailureAction;

export type DeleteTruckTemplatesRequestAction = DataAction<ActionType.DELETE_TRUCK_TEMPLATES_REQUEST, Template>;
export type DeleteTruckTemplatesSuccessAction = DataAction<ActionType.DELETE_TRUCK_TEMPLATES_SUCCESS, string>;
export type DeleteTruckTemplatesFailureAction = ErrorAction<ActionType.DELETE_TRUCK_TEMPLATES_FAILURE>;

export type DeleteTruckTemplatesAction =
  DeleteTruckTemplatesRequestAction |
  DeleteTruckTemplatesSuccessAction |
  DeleteTruckTemplatesFailureAction;

export type Action =
  | GetTruckTemplatesAction
  | CreateTruckTemplatesAction
  | UpdateTruckTemplatesAction
  | DeleteTruckTemplatesAction;

export const getTruckTemplates = {
  request: (): GetTruckTemplatesRequestAction => ({
    type: ActionType.GET_TRUCK_TEMPLATES_REQUEST,
  }),
  failure: (error: string): GetTruckTemplatesFailureAction => ({
    error,
    type: ActionType.GET_TRUCK_TEMPLATES_FAILURE,
  }),
  success: (data: Template[]): GetTruckTemplatesSuccessAction => ({
    data,
    type: ActionType.GET_TRUCK_TEMPLATES_SUCCESS,
  }),
};

export const createTruckTemplate = {
  request: (data: Omit<Template, 'id'>): CreateTruckTemplatesRequestAction => ({
    data,
    type: ActionType.CREATE_TRUCK_TEMPLATES_REQUEST,
  }),
  failure: (error: string): CreateTruckTemplatesFailureAction => ({
    error,
    type: ActionType.CREATE_TRUCK_TEMPLATES_FAILURE,
  }),
  success: (data: Template): CreateTruckTemplatesSuccessAction => ({
    data,
    type: ActionType.CREATE_TRUCK_TEMPLATES_SUCCESS,
  }),
};

export const updateTruckTemplate = {
  request: (data: Template): UpdateTruckTemplatesRequestAction => ({
    data,
    type: ActionType.UPDATE_TRUCK_TEMPLATES_REQUEST,
  }),
  failure: (error: string): UpdateTruckTemplatesFailureAction => ({
    error,
    type: ActionType.UPDATE_TRUCK_TEMPLATES_FAILURE,
  }),
  success: (data: Template): UpdateTruckTemplatesSuccessAction => ({
    data,
    type: ActionType.UPDATE_TRUCK_TEMPLATES_SUCCESS,
  }),
};

export const deleteTruckTemplate = {
  request: (data: Template): DeleteTruckTemplatesRequestAction => ({
    data,
    type: ActionType.DELETE_TRUCK_TEMPLATES_REQUEST,
  }),
  failure: (error: string): DeleteTruckTemplatesFailureAction => ({
    error,
    type: ActionType.DELETE_TRUCK_TEMPLATES_FAILURE,
  }),
  success: (data: string): DeleteTruckTemplatesSuccessAction => ({
    data,
    type: ActionType.DELETE_TRUCK_TEMPLATES_SUCCESS,
  }),
};
